import { useState, useEffect } from "react";

import {
    obtenerBannersComunidad,
    obtenerBannerComunidad,
    crearBannerComunidad,
    editarBannerComunidad,
    eliminarBannerComunidad,
    getBannerComunidadPublic
} from "../Services/Banner";

export const useBannerComunidadPublic = () => {
    const [banner, setBanner] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchBanner = async () => {
        try {
            setLoading(true);

            const data = await getBannerComunidadPublic();

            setBanner(data);
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBanner();
    }, []);

    return {
        banner,
        loading,
        error,
        fetchBanner,
    };
};

export const useBannerComunidad = () => {

    const [banners, setBanners] = useState([]);

    const [banner, setBanner] = useState(null);

    const [loading, setLoading] = useState(false);

    const [error, setError] = useState(null);


    /*
    |--------------------------------------------------------------------------
    | OBTENER TODOS LOS BANNERS
    |--------------------------------------------------------------------------
    */

    const cargarBanners = async () => {

        try {

            setLoading(true);
            setError(null);

            const data =
                await obtenerBannersComunidad();

            setBanners(data);

            return data;

        } catch (err) {

            console.error(
                "Error al obtener banners:",
                err
            );

            setError(err);

            return null;

        } finally {

            setLoading(false);

        }
    };


    /*
    |--------------------------------------------------------------------------
    | OBTENER BANNER POR ID
    |--------------------------------------------------------------------------
    */

    const cargarBanner = async (id) => {

        try {

            setLoading(true);
            setError(null);

            const data =
                await obtenerBannerComunidad(id);

            setBanner(data);

            return data;

        } catch (err) {

            console.error(
                "Error al obtener banner:",
                err
            );

            setError(err);

            return null;

        } finally {

            setLoading(false);

        }
    };


    /*
    |--------------------------------------------------------------------------
    | CREAR BANNER
    |--------------------------------------------------------------------------
    */

    const crearBanner = async (formData) => {

        try {

            setLoading(true);
            setError(null);

            const response =
                await crearBannerComunidad(
                    formData
                );

            // Agregar el nuevo banner
            // a la lista actual

            if (response?.data) {

                setBanners((prev) => [
                    ...prev,
                    response.data,
                ]);

            }

            return response;

        } catch (err) {

            console.error(
                "Error al crear banner:",
                err
            );

            setError(err);

            throw err;

        } finally {

            setLoading(false);

        }
    };


    /*
    |--------------------------------------------------------------------------
    | EDITAR BANNER
    |--------------------------------------------------------------------------
    */

    const editarBanner = async (
        id,
        formData
    ) => {

        try {

            setLoading(true);
            setError(null);

            const response =
                await editarBannerComunidad(
                    id,
                    formData
                );


            if (response?.data) {

                setBanners((prev) =>
                    prev.map((item) =>
                        item.id === id
                            ? response.data
                            : item
                    )
                );


                setBanner(response.data);

            }

            return response;

        } catch (err) {

            console.error(
                "Error al editar banner:",
                err
            );

            setError(err);

            throw err;

        } finally {

            setLoading(false);

        }
    };


    /*
    |--------------------------------------------------------------------------
    | ELIMINAR BANNER
    |--------------------------------------------------------------------------
    */

    const eliminarBanner = async (id) => {

        try {

            setLoading(true);
            setError(null);

            const response =
                await eliminarBannerComunidad(id);


            setBanners((prev) =>
                prev.filter(
                    (item) => item.id !== id
                )
            );


            return response;

        } catch (err) {

            console.error(
                "Error al eliminar banner:",
                err
            );

            setError(err);

            throw err;

        } finally {

            setLoading(false);

        }
    };


    /*
    |--------------------------------------------------------------------------
    | RETURN
    |--------------------------------------------------------------------------
    */

    return {

        banners,

        banner,

        loading,

        error,

        cargarBanners,

        cargarBanner,

        crearBanner,

        editarBanner,

        eliminarBanner,

    };
};